import marked from 'marked'

export default function (input, options = {}) {
	if (!input) return input
	return marked(input, options)
}



// WEBPACK FOOTER //
// ./src/lib/filters/markdown.js